/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum DataModelSalaryRangeMassCompositeUpdateAction {
    INCLUDE = 'include',
    EXCLUDE = 'exclude',
    LOCK = 'lock',
    UNLOCK = 'unlock',
}
